import React from 'react';

const InfinityLoader = () => (
  <div className="o-flexbox o-flexbox__item u-justify-content-center u-m-">
    <div className="c-loader__spin" data-automation-id="icon:loading" />
  </div>
);

export default InfinityLoader;
